export default __webpack_public_path__ + "static/media/winner5.86b75538.jpg";